var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSbLevel1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 88 34",
    style: {
      enableBackground: "new 0 0 88 34"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#061133;}\r\n\t.st2{fill:#DEDEDE;}\r\n\t.st3{fill:#FFFFFF;stroke:#0F1325;stroke-width:0.3424;}\r\n\t.st4{fill:#A6A6A6;}\r\n\t.st5{fill:none;stroke:#0F1325;stroke-width:0.303;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st6{fill:none;stroke:#0F1325;stroke-width:0.2926;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st7{fill:none;stroke:#0F1325;stroke-width:0.31;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st8{fill:none;stroke:#0F1325;stroke-width:0.3065;stroke-linecap:round;stroke-linejoin:round;}\r\n\t.st9{enable-background:new    ;}\r\n\t.st10{fill:none;}\r\n\t.st11{fill:#5B3061;}\r\n\t.st12{fill:#F98526;}\r\n\t.st13{fill:#28B6EA;}\r\n\t.st14{fill:#B44784;}\r\n\t.st15{fill:#CA1D2A;}\r\n\t.st16{fill:#86BC44;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,0h57c3.9,0,7,3.1,7,7v20c0,3.9-3.1,7-7,7H7c-3.9,0-7-3.1-7-7V7C0,3.1,3.1,0,7,0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M81,0H64H7C3.1,0,0,3.1,0,7v20c0,3.9,3.1,7,7,7h57h17c3.9,0,7-3.1,7-7V7C88,3.1,84.9,0,81,0z M7,32.5 c-3,0-5.5-2.5-5.5-5.5V7C1.5,4,4,1.5,7,1.5h57c3,0,5.5,2.5,5.5,5.5v20c0,3-2.5,5.5-5.5,5.5H7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M19.8,24.5h-2.3v-9.2c0-1.1,0-2,0.1-2.6c-0.1,0.2-0.3,0.3-0.6,0.5S16.1,14,14.9,15l-1.2-1.5l4.2-3.3h1.9V24.5z "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3164_00000147913105468623256920000018071539345469447093_",
    transform: "translate(19294.49 -18416.314)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1817_00000030458441627089140060000016430039097897412026_",
    className: "st2",
    d: "M-19263.5,18436.9h8.8 c0.3,0,0.5,0.2,0.5,0.5v6.3c0,0.3-0.2,0.5-0.5,0.5h-8.8c-0.3,0-0.5-0.2-0.5-0.5v-6.3 C-19264,18437.1-19263.7,18436.9-19263.5,18436.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1818_00000094579701369575672470000013778923214625275823_",
    className: "st3",
    d: "M-19262.4,18438.1h6.6 c0.2,0,0.4,0.2,0.4,0.4v4.2c0,0.2-0.2,0.4-0.4,0.4h-6.6c-0.2,0-0.4-0.2-0.4-0.4v-4.2 C-19262.7,18438.3-19262.6,18438.1-19262.4,18438.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1819_00000171715437716563391590000009068437314066111667_",
    className: "st2",
    d: "M-19251.8,18422.3h8 c0.5,0,0.9,0.4,0.9,0.9v20.2c0,0.5-0.4,0.9-0.9,0.9h-8c-0.5,0-0.9-0.4-0.9-0.9v-20.2 C-19252.7,18422.7-19252.3,18422.3-19251.8,18422.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1820_00000137103700667110461920000000639213924892121747_",
    className: "st3",
    d: "M-19251.1,18438.1h6.6 c0.2,0,0.4,0.2,0.4,0.4v4.2c0,0.2-0.2,0.4-0.4,0.4h-6.6c-0.2,0-0.4-0.2-0.4-0.4v-4.2 C-19251.5,18438.3-19251.3,18438.1-19251.1,18438.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1821_00000088107904794269935060000015861926770336558512_",
    className: "st3",
    d: "M-19251.1,18430.8h6.6 c0.2,0,0.4,0.2,0.4,0.4v4.2c0,0.2-0.2,0.4-0.4,0.4h-6.6c-0.2,0-0.4-0.2-0.4-0.4v-4.2 C-19251.5,18430.9-19251.3,18430.8-19251.1,18430.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1822_00000101091392210931269250000007785140768506383242_",
    className: "st3",
    d: "M-19251.1,18423.4h6.6 c0.2,0,0.4,0.2,0.4,0.4v4.2c0,0.2-0.2,0.4-0.4,0.4h-6.6c-0.2,0-0.4-0.2-0.4-0.4v-4.2 C-19251.5,18423.6-19251.3,18423.4-19251.1,18423.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1823_00000024713137768339772630000013747124383779189916_",
    className: "st4",
    d: "M-19241,18429.5h8.8 c0.3,0,0.5,0.2,0.5,0.5v6.3c0,0.3-0.2,0.5-0.5,0.5h-8.8c-0.3,0-0.5-0.2-0.5-0.5v-6.3 C-19241.5,18429.8-19241.2,18429.5-19241,18429.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1824_00000138563164145317304930000003138348495517507770_",
    className: "st3",
    d: "M-19239.9,18430.8h6.6 c0.2,0,0.4,0.2,0.4,0.4v4.2c0,0.2-0.2,0.4-0.4,0.4h-6.6c-0.2,0-0.4-0.2-0.4-0.4v-4.2 C-19240.2,18430.9-19240.1,18430.8-19239.9,18430.8z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3160_00000056423031897491721780000012855687375497946790_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50-7_00000029762212315160228840000007298981114179091595_",
    className: "st5",
    d: "M-19255.3,18440.5h3.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-7_00000008848821164029691880000017806625228613203900_",
    className: "st6",
    d: "M-19252.3,18440l0.5,0.5l-0.5,0.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3161_00000178906122678217966970000017674969872644452484_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50-7-2_00000058559632133891875240000000360450721279906446_",
    className: "st6",
    d: "M-19243.7,18433.2h3.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-7-2_00000059272912223387628470000006278569737548729735_",
    className: "st6",
    d: "M-19241.1,18432.7l0.5,0.5l-0.5,0.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-7-3_00000052787153440699379240000004814635088956143522_",
    className: "st6",
    d: "M-19243.3,18433.8l-0.5-0.5l0.5-0.5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3162_00000039101015076302795840000016797642757135072159_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50-7-3_00000082331202844396449830000011239738758846905228_",
    className: "st7",
    d: "M-19247.8,18435.8v2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-7-4_00000151528738582697690040000006146471749319460260_",
    className: "st6",
    d: "M-19247.2,18437.3l-0.5,0.5l-0.5-0.5 "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3163_00000026860291768736178750000008039986771155525545_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50-7-4_00000178202453187644447720000017554794023462799768_",
    className: "st8",
    d: "M-19247.8,18428.5v1.9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51-7-5_00000032613426756318908020000011691239837229867195_",
    className: "st6",
    d: "M-19247.2,18430l-0.5,0.5l-0.5-0.5"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSbLevel1);
export default __webpack_public_path__ + "static/media/Icon-SB-Level-1.7e6d3bbd400736b04ba3225ec14352c1.svg";
export { ForwardRef as ReactComponent };